import { steps as driverSteps, heading as driverHeading } from './steps/driver'
// import { steps as warehouseSteps, heading as warehouseHeading } from './steps/warehouse'

export const heading = driverHeading

export const steps = driverSteps

export const fields = steps.reduce((stepFields, step) => {
  Object.keys(step.inputs || {}).forEach(key => {
    stepFields[key] = step.inputs[key].default || ''
  })

  return stepFields
}, {})
